module.exports = {"heading":"Choose a vehicle of interest to claim your offer."}